<template>
  <DataGridColumn v-if="tableColumn.childColumns"
                  :title="tableColumn.name"
                  :align="tableColumn.alignType || 'center'"
                  :width="tableColumn.width"
                  :min-width="minColumnWidth"
                  :max-width="tableColumn.maxWidth">
    <CompositeTableColumn v-if="tableColumn.childColumns"
                          v-for="(column, index) in tableColumn.childColumns"
                          :key="'column_' + index"
                          :table-column="column"
                          :table-column-cell-render="tableColumnCellRender"
                          v-bind="$attrs"
                          v-on="$listeners">
    </CompositeTableColumn>
  </DataGridColumn>
  <DataGridColumnWrapper v-else-if="tableColumn.isListable"
                         :field="tableColumn.prop"
                         :title="tableColumn.name"
                         :fixed="tableColumn.fixedType"
                         :align="tableColumn.alignType || 'left'"
                         :visible="!tableColumn.isHidden"
                         :sortable="tableColumn.isSortable"
                         :aggregation="tableColumn.isAggregation"
                         :width="tableColumn.width"
                         :min-width="minColumnWidth"
                         :max-width="tableColumn.maxWidth"
                         :table-column="tableColumn"
                         :table-column-cell-render="tableColumnCellRender">
    <template slot-scope="scope">
      <CompositeTableActionCell v-if="tableColumn.renderAction"
                                :key="scope.column.id + '_' + scope.row.id"
                                :table-column="tableColumn"
                                :table-column-cell-render="tableColumnCellRender"
                                :row-index="scope.rowIndex"
                                :row-data="scope.row"
                                :is__hidden="scope.isHidden"
                                v-bind="$attrs"
                                v-on="$listeners">
      </CompositeTableActionCell>
      <CompositeTableRenderCell v-else
                                :key="scope.column.id + '_' + scope.row.id"
                                :table-column="tableColumn"
                                :table-column-cell-render="tableColumnCellRender"
                                :row-index="scope.rowIndex"
                                :row-data="scope.row"
                                :is__hidden="scope.isHidden"
                                v-bind="$attrs"
                                v-on="$listeners">
      </CompositeTableRenderCell>
    </template>
  </DataGridColumnWrapper>
</template>

<script>
import DataGridColumn from '../DataGridColumn'
import DataGridColumnWrapper from './DataGridColumnWrapper'
import CompositeTableActionCell from './CompositeTableActionCell'
import CompositeTableRenderCell from './CompositeTableRenderCell'

export default {
  name: 'CompositeTableColumn',
  components: {DataGridColumn, DataGridColumnWrapper, CompositeTableActionCell, CompositeTableRenderCell},
  props: {
    tableColumn: {
      type: Object,
      required: true
    },
    tableColumnCellRender: {
      type: Function,
      required: true
    }
  },
  data () {
    return {
      minColumnWidth: 100
    }
  }
}
</script>
